var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative" },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "card-info-root" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _vm._v(" \n        Carregando anexos...\n    ")
          ])
        : _vm.attachmentsTypes.length > 0
        ? _c(
            "div",
            [
              _c(
                "Tabs",
                _vm._l(_vm.attachmentsTypes, function(attachmentType) {
                  return _c(
                    "TabPane",
                    { key: attachmentType.id },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "position-relative",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(attachmentType.descricao))
                          ]),
                          _vm._v(" "),
                          _vm.countAttachmentsByType(attachmentType.id) > 0
                            ? _c("span", { staticClass: "card-chip" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.countAttachmentsByType(
                                        attachmentType.id
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("Attachment", {
                        key: attachmentType.id,
                        attrs: {
                          "tipo-anexo": attachmentType,
                          anexos: _vm.payload.anexos
                        },
                        on: { removeAnexo: _vm.removeAttachment }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _c("Empty", { attrs: { description: "Nenhum anexo disponível" } }),
      _vm._v(" "),
      this.$store.getters["user/isAnyRole"](["adm", "cadastro", "financeiro"])
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              !_vm.isLoading
                ? _c(
                    "Button",
                    {
                      attrs: {
                        type: "primary",
                        plain: "",
                        disabled: _vm.isSubmiting
                      },
                      on: {
                        click: function($event) {
                          return _vm.onSubmit()
                        }
                      }
                    },
                    [
                      _vm._v("\n            Salvar Anexos\n            "),
                      !_vm.isSubmiting
                        ? _c("i", { staticClass: "el-icon-right" })
                        : _c("i", { staticClass: "el-icon-loading" })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9d485c8e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d485c8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_prospecto/partials/Anexos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9d485c8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_prospecto/partials/Anexos.vue
// module chunks = 2